import { stringify } from "query-string";
import { getEnv } from "../../configs/env";
import { callApiNoToken, callApi } from "../../utils/request";
import Storage from "../../utils/storega";
import { setLoadingApp } from "./common";

/**
 * Teacher login for GAI_BU (加盟校)
 * POST /auth/teacher-login-gaihan
 */
const teacherLoginGaihan = ({ schoolId, username, password, onSuccess = () => {}, onError = () => {} }) => {
  const url = `${getEnv("REACT_APP_API_SERVER")}/auth/teacher-login-gaihan`;
  const config = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json"
    },
    body: JSON.stringify({ schoolId, username, password })
  };

  return (dispatch) => {
    dispatch(setLoadingApp(true));
    callApiNoToken(
      url,
      config,
      null,
      (response) => {
        dispatch(setLoadingApp(false));
        const { data } = response;
        Storage.set("TEACHER_ACCESS_TOKEN", data.token);
        Storage.set("TEACHER_INFO", {
          userId: data.userId,
          userName: data.userName,
          schoolId: data.schoolId,
          role: data.role
        });
        Storage.set("SYSTEM_CODE", "2"); // GAI_BU
        Storage.set("SCHOOL_ID", schoolId);
        onSuccess(data);
      },
      (err) => {
        dispatch(setLoadingApp(false));
        onError({
          status: err?.errors?.messageId,
          message: err?.errors?.message
        });
      }
    );
  };
};

/**
 * Get school buildings filtered by teacherId
 * GET /auth/school-buildings-gaihan — protected endpoint (Spring Security validates JWT)
 */
const getTeacherBuildings = ({ schoolId, onSuccess = () => {}, onError = () => {} }) => {
  const info = Storage.get("TEACHER_INFO");
  const teacherId = info?.userId;
  const token = Storage.get("TEACHER_ACCESS_TOKEN");

  const url = `${getEnv("REACT_APP_API_SERVER")}/auth/school-buildings-gaihan?${stringify({
    isGetAll: true,
    schoolId,
    teacherId
  })}`;

  const config = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: `Bearer ${token}`
    }
  };

  return (dispatch) => {
    dispatch(setLoadingApp(true));
    callApi(
      url,
      config,
      null,
      (r) => {
        const buildings = r?.data?.content || [];
        Storage.set("SCHOOL_BUILDING_LIST", buildings);
        dispatch(setLoadingApp(false));
        onSuccess(buildings);
      },
      (err) => {
        dispatch(setLoadingApp(false));
        onError({
          status: err?.errors?.messageId,
          message: err?.errors?.message
        });
      }
    );
  };
};

export { teacherLoginGaihan, getTeacherBuildings };
